import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect, useState } from 'react';
import { BookerContext } from '../Booker/index.js';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { getQuoteRequest, getSaveTripRequest } from '../../utils/addOnUtils.js';
import { AddOn } from '../AddOn/index.js';
import { AddOnEmpty } from '../AddOn/AddOnEmpty.js';
import { getDetailedServiceForm } from '../../utils/bookerUtils.js';
import { ServiceBooker } from './ServiceBooker.js';
import { ServiceBookerLoading } from './ServiceBookerLoading.js';
const Group = ({ children }) => {
    const { useTailwindPrefix } = useContext(BookerContext);
    return (_jsx("div", Object.assign({ className: classNames({
            'flex flex-col pl-0 mb-0 last:rounded-b': !useTailwindPrefix,
            'tw-flex tw-flex-col tw-pl-0 tw-mb-0 last:tw-rounded-b': useTailwindPrefix,
        }) }, { children: children })));
};
Group.Item = ({ children, onClick }) => {
    const { useTailwindPrefix } = useContext(BookerContext);
    const onClickEvent = () => {
        onClick();
    };
    return (_jsx("div", Object.assign({ className: classNames({
            'relative flex justify-between items-center py-3 px-5 bg-white border-b border-gray-200 last:border-b-0 last:rounded-b-[inherit] cursor-pointer': !useTailwindPrefix,
            'tw-relative tw-flex tw-justify-between tw-items-center tw-py-3 tw-px-5 tw-bg-white tw-border-b tw-border-gray-200 last:tw-border-b-0 last:tw-rounded-b-[inherit] tw-cursor-pointer': useTailwindPrefix,
        }) }, (onClick && { onClick: onClickEvent }), { children: children })));
};
const Title = ({ children, single }) => {
    const { useTailwindPrefix } = useContext(BookerContext);
    return (_jsx("div", Object.assign({ className: classNames({
            'relative flex justify-between py-3 px-5 bg-white border-b border-gray-200 last:border-b-0 last:rounded-b-[inherit] font-semibold rounded-t': !useTailwindPrefix,
            'tw-relative tw-flex tw-justify-between tw-py-3 tw-px-5 tw-bg-white tw-border-b tw-border-gray-200 last:tw-border-b-0 last:tw-rounded-b-[inherit] tw-font-semibold tw-rounded-t': useTailwindPrefix,
        }) }, { children: single ? (_jsx("div", Object.assign({ className: classNames({
                'grow text-center': !useTailwindPrefix,
                'tw-grow tw-text-center': useTailwindPrefix,
            }) }, { children: children }))) : (children) })));
};
const Back = ({ children, onClick }) => {
    const { useTailwindPrefix } = useContext(BookerContext);
    const onClickEvent = () => {
        onClick();
    };
    return (_jsx("div", Object.assign({ className: classNames({
            'cursor-pointer px-[10px] py-[20px] -mx-[12px] -my-[20px]': !useTailwindPrefix,
            'tw-cursor-pointer tw-px-[10px] tw-py-[20px] -tw-mx-[12px] -tw-my-[20px]': useTailwindPrefix,
        }) }, (onClick && { onClick: onClickEvent }), { children: children })));
};
const QuoteList = ({ children }) => {
    const { useTailwindPrefix } = useContext(BookerContext);
    return (_jsx("ul", Object.assign({ className: classNames({
            'flex flex-col pl-0 mb-2 rounded-none': !useTailwindPrefix,
            'tw-flex tw-flex-col tw-pl-0 tw-mb-2 tw-rounded-none': useTailwindPrefix,
        }) }, { children: children })));
};
QuoteList.Item = ({ children }) => {
    const { useTailwindPrefix } = useContext(BookerContext);
    return (_jsx("li", Object.assign({ className: classNames({
            'border-b border-gray-200 relative block py-3 px-5 bg-white last:border-b-0': !useTailwindPrefix,
            'tw-border-b tw-border-gray-200 tw-relative tw-block tw-py-3 tw-px-5 tw-bg-white last:tw-border-b-0': useTailwindPrefix,
        }) }, { children: children })));
};
const ServiceSelector = ({ serviceForm, hotelList, getAddOnList, addOnListWrapper, clearAddOnList, quoteListWrapper, clearQuoteList, showClearDate, onQuote, onSubmit, }) => {
    const { hotelId, currency, type, serviceId: addOnId } = serviceForm;
    const { useTailwindPrefix, locale } = useContext(BookerContext);
    const [selectedHotelId, setSelectedHotelId] = useState(0);
    const [serviceId, setServiceId] = useState(0);
    const [variationId, setVariationId] = useState(0);
    const [quoteData, setQuoteData] = useState({});
    const [showResume, setShowResume] = useState(false);
    const intl = useIntl();
    useEffect(() => {
        // if ((serviceForm.hotelId && serviceForm.hotelId !== 0) || selectedHotelId !== 0) {
        getAddOnList({
            hotelId: hotelId || selectedHotelId,
            type,
            currency,
            standalone: true,
        });
        // }
    }, [selectedHotelId]);
    function onReturnServices() {
        setSelectedHotelId(0);
        clearAddOnList();
    }
    function onReturn(returnToService) {
        if (quoteListWrapper.isPristine) {
            setServiceId(0);
        }
        setShowResume(false);
        clearQuoteList();
        if (!returnToService) {
            setSelectedHotelId(0);
        }
    }
    function onChangeDates(value) {
        setShowResume(value);
        if (!value) {
            clearQuoteList();
        }
    }
    const onQuoteEvent = (addOn) => (data) => {
        setQuoteData(data);
        const request = getQuoteRequest(Object.assign({ currency, language: locale }, data), addOn);
        onQuote && onQuote(request);
    };
    const reserve = (addOn, dataHotelId) => (item) => {
        let defaultHotelId = dataHotelId;
        if (!defaultHotelId || defaultHotelId <= 0) {
            defaultHotelId = hotelId || selectedHotelId;
        }
        const request = getSaveTripRequest(addOn, item, currency, defaultHotelId, // en caso de que el addon no traiga hotelId se usa el seleccionado
        locale, quoteData);
        setVariationId(item.id);
        if (onSubmit && typeof onSubmit === 'function') {
            onSubmit(request, () => setVariationId(0));
        }
    };
    function drawQuoteList(addOn) {
        const items = quoteListWrapper.data ? quoteListWrapper.data.items : [];
        const error = quoteListWrapper.data && quoteListWrapper.data.error;
        const hotelId = quoteListWrapper.data ? quoteListWrapper.data.hotelId : null;
        if (!quoteListWrapper.isFetching && quoteListWrapper.data && (items.length === 0 || error)) {
            return (_jsx(QuoteList, { children: _jsx(QuoteList.Item, { children: _jsx(AddOnEmpty, { error: quoteListWrapper.hasError || error, errorText: error ? quoteListWrapper.data.errors.join('. ') : null }) }) }));
        }
        else {
            return (_jsx(QuoteList, { children: items.map((item) => {
                    let content = {
                        title: addOn.title,
                        description: addOn.description,
                    };
                    if (addOn.variations.length > 1) {
                        let variation = addOn.variations.find((variation) => variation.id === item.id);
                        if (variation) {
                            content = { title: variation.name, description: variation.description || '' };
                        }
                    }
                    if (item.error) {
                        return (_jsx(QuoteList.Item, { children: _jsx(AddOnEmpty, { error: item.error }) }, item.id));
                    }
                    return (_jsx(QuoteList.Item, { children: _jsx(AddOn, { item: item, content: content, currency: currency, onSelect: reserve(addOn, hotelId), selectedVariationId: variationId, addOn: addOn }) }, item.id));
                }) }));
        }
    }
    function drawBooker() {
        const services = addOnListWrapper.items.filter((item) => {
            return item.isActive === true && (addOnId && addOnId !== 0 ? item.id === addOnId : true);
        });
        if (serviceId > 0 || services.length === 1) {
            const service = serviceId > 0 ? services.find((service) => service.id === serviceId) : services[0];
            return (_jsxs(_Fragment, { children: [(services.length > 1 || ((hotelList === null || hotelList === void 0 ? void 0 : hotelList.length) > 0 && selectedHotelId > 0)) && (_jsxs(Title, { children: [_jsx(Back, Object.assign({ onClick: () => onReturn(services.length > 1) }, { children: _jsx(FontAwesomeIcon, { icon: faChevronLeft }) })), quoteListWrapper.isPristine ? (_jsx("div", { children: intl.formatMessage({ id: 'daypass.dateAndPeople' }) })) : (_jsx("div", { children: intl.formatMessage({ id: 'daypass.options' }) })), _jsx("div", { children: "\u00A0" })] })), service && (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: classNames({
                                    'p-5': !useTailwindPrefix,
                                    'tw-p-5': useTailwindPrefix,
                                }) }, { children: [_jsx("div", Object.assign({ className: classNames({
                                            ' mb-3': !useTailwindPrefix,
                                            'tw-mb-3': useTailwindPrefix,
                                        }) }, { children: _jsx("strong", { children: service.title }) })), _jsx(ServiceBooker, { serviceForm: getDetailedServiceForm(serviceForm, service, onQuoteEvent), showResume: showResume, showClearDate: showClearDate, setResume: onChangeDates, onSubmit: onSubmit })] })), _jsxs("div", Object.assign({ className: classNames({
                                    'relative min-h-[7em] border-t border-gray-200': !useTailwindPrefix,
                                    'tw-relative tw-min-h-[7em] tw-border-t tw-border-gray-200': useTailwindPrefix,
                                }) }, (quoteListWrapper.isPristine && { style: { display: 'none' } }), { children: [quoteListWrapper.isFetching && (_jsx("div", Object.assign({ className: classNames({
                                            'absolute inset-0 bg-[#ddd] z-[1] opacity-50 pt-10 text-center': !useTailwindPrefix,
                                            'tw-absolute tw-inset-0 tw-bg-[#ddd] tw-z-[1] tw-opacity-50 tw-pt-10 tw-text-center': useTailwindPrefix,
                                        }) }, { children: _jsx(FontAwesomeIcon, { icon: faCircleNotch, size: "2x", spin: true }) }))), drawQuoteList(service)] }))] }))] }));
        }
        return (_jsxs(Group, { children: [hotelList && hotelList.length > 0 && selectedHotelId > 0 ? (_jsxs(Title, { children: [_jsx(Back, Object.assign({ onClick: onReturnServices }, { children: _jsx(FontAwesomeIcon, { icon: faChevronLeft }) })), _jsx("div", { children: intl.formatMessage({ id: 'daypass.chooseService' }) }), _jsx("div", { children: "\u00A0" })] })) : (_jsx(Title, Object.assign({ single: true }, { children: intl.formatMessage({ id: 'daypass.chooseService' }) }))), services.length === 0 ? (_jsx(Title, Object.assign({ single: true }, { children: intl.formatMessage({ id: 'daypass.noService' }) }))) : (services.map((service) => (_jsxs(Group.Item, Object.assign({ onClick: () => setServiceId(service.id) }, { children: [service.title, _jsx(FontAwesomeIcon, { icon: faChevronRight })] }), service.id))))] }));
    }
    return (_jsxs("div", Object.assign({ className: classNames({
            'relative flex flex-col min-w-0 break-words bg-clip-border border border-gray-200 rounded bg-white': !useTailwindPrefix,
            'tw-relative tw-flex tw-flex-col tw-min-w-0 tw-break-words tw-bg-clip-border tw-border tw-border-gray-200 tw-rounded tw-bg-white': useTailwindPrefix,
        }) }, { children: [_jsx("div", Object.assign({ className: classNames({
                    'px-5 py-3 mb-0 bg-black/[0.03] border-b border-gray-200 hidden rounded-t-[inherit]': !useTailwindPrefix,
                    'tw-px-5 tw-py-3 tw-mb-0 tw-bg-black/[0.03] tw-border-b tw-border-gray-200 tw-hidden tw-rounded-t-[inherit]': useTailwindPrefix,
                }) }, { children: intl.formatMessage({ id: 'daypass.book' }) })), (hotelList === null || hotelList === void 0 ? void 0 : hotelList.length) > 1 && !serviceForm.hotelId && !selectedHotelId ? (_jsxs(Group, { children: [_jsx(Title, Object.assign({ single: true }, { children: intl.formatMessage({ id: 'daypass.chooseHotel' }) })), hotelList.map((hotel) => (_jsxs(Group.Item, Object.assign({ onClick: () => setSelectedHotelId(hotel.id) }, { children: [hotel.name, _jsx(FontAwesomeIcon, { icon: faChevronRight })] }), hotel.id)))] })) : (_jsxs(_Fragment, { children: [addOnListWrapper.isFetching && !addOnListWrapper.isPristine && (_jsx("div", Object.assign({ className: classNames({
                            'p-5': !useTailwindPrefix,
                            'tw-p-5': useTailwindPrefix,
                        }) }, { children: _jsx(ServiceBookerLoading, {}) }))), !addOnListWrapper.isFetching && !addOnListWrapper.isPristine && drawBooker()] }))] })));
};
export default ServiceSelector;
